<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>New category</h2>
        </div>
        <div slot="body">
            <category-form @toggleIsDisabled="toggleIsDisabled" @readyToSave="readyToSave"></category-form>
        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="save" :disabled="isDisabled">Save</button>
        </div>
    </modal>
</template>
   
<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import CategoryForm from '@/components/inventory/categories/CategoryForm'

    export default {
        data: function() {
            return {
                isDisabled: true,
                updatedForm: null,
            }
        },
        computed: {
            ...mapGetters([
                'account',
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'addItem'
            ]),
            toggleIsDisabled: function(isDisabled) {
                this.isDisabled = isDisabled;
            },
            cancel: function() {
                this.closeModal();
            },
            readyToSave: function(updatedForm) {
                this.updatedForm = updatedForm;
            },
            save: function() {
                if (this.updatedForm) {
                    this.addItem({
                        object: 'category',
                        action: 'create',
                        table: 'categories',
                        fields: { supplierId: this.account.supplierId, category: this.updatedForm }
                    });
                }
            }
        },
        components: {
            Modal,
            CategoryForm,
        }
    }
</script>


// WEBPACK FOOTER //
// CategoryAdd.vue?a6b83a88